import { CloseModalEvent } from "./events/closeModal.event";
import { CookieSetEvent } from "./events/cookieSet.event";
import { FeatureToggleChangeEvent } from "./events/featureToggleChange.event";
import { HeaderButtonActivatedEvent } from "./events/headerButtonActivated.event";
import { InfoblockOpenedEvent } from "./events/infoblockOpened.event";
import { OneTrustLoadedEvent } from "./events/oneTrustLoaded.event";

export const WindowEvent = {
    FeatureToggleChange: "featuretogglechange",
    CookieSet: "cookieset",
    InfoblockOpened: "infoBlock.opened",
    CloseModal: "close-modal",
    HeaderButtonActivated: "header-button-activated",
    OneTrustLoaded: "onetrustloaded"
} as const;

export type WindowEvent = (typeof WindowEvent)[keyof typeof WindowEvent];

export type CustomWindowEventMap = {
    [WindowEvent.FeatureToggleChange]: FeatureToggleChangeEvent;
    [WindowEvent.CookieSet]: CookieSetEvent;
    [WindowEvent.InfoblockOpened]: InfoblockOpenedEvent;
    [WindowEvent.CloseModal]: CloseModalEvent;
    [WindowEvent.HeaderButtonActivated]: HeaderButtonActivatedEvent;
    [WindowEvent.OneTrustLoaded]: OneTrustLoadedEvent;
};
